import React from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getProject } from 'src/old-app/store/projectsSlice'
import { dialogActions } from 'src/old-app/store/dialogSlice'
import { UserShow } from '../../../../shared/components'
import { Link } from 'react-router-dom'
import TaskListItem from '../../../../old-app/main/tasks/TaskListItem'

import EmptyPlaceholder from '../../../../shared/components/empty-placeholder'
import { useGetProjectsQuery } from '../../../../old-app/service/Projects'
import { useTeamShow } from '../../hooks'
import SubProjectRow from '../../../project/components/sub-project-row'
import { useGetTeamProjectsQuery } from '../../../../old-app/service/Teams'
import { ProjectRequestTable } from '../../../project'

interface IProps {
	curPage?: string
}

const TeamProjectRequests: React.FC<IProps> = ({ curPage }) => {
	const { team } = useTeamShow()

	return <ProjectRequestTable curPage={curPage} params={{ command_id: team?.id }} />
}

export default TeamProjectRequests
